/* global Swiper */

/**
 * Initialize Swiper slider for testimonial block
 * @param {HTMLElement} block - The testimonial block
 * @return {void}
 */
const initializeSwiper = ( block ) => {

	let swiperInstance;
	if ( !swiperInstance ) {

		const index = Math.floor( Math.random() * 100000 );
		const sliderContainer = block.querySelector( '.b-related-posts__inner' );
		const slidesNum = block.dataset.slidesNum;
		const loop = !isNaN( Number( slidesNum ) ) && slidesNum > 3;

		if ( slidesNum < 2 ) {

			return;

		}

		if ( sliderContainer && sliderContainer.classList.contains( 'swiper' ) ) {

			// add unique class to each slider, so they might work separately
			sliderContainer.classList.add( `slider-${index}` );

		}

		swiperInstance = new Swiper( block.querySelector( `.slider-${index}` ), {
			loop: loop,
			speed: 800,
			grabCursor: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			preloadImages: true,
			lazy: true,
			allowTouchMove: true,
			breakpoints: breakpoints,
			spaceBetween: 0,
			centeredSlides: false,
			slidesOffsetAfter: 40,
			navigation: {
				nextEl: '.b-related-posts .swiper-button-next',
				prevEl: '.b-related-posts .swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'custom',
				// eslint-disable-next-line func-names, require-jsdoc
				renderCustom: function ( swiper ) {

					const current = swiper.realIndex + 1
					return `<span class="swiper-pagination-current">${current}</span> / <span class="swiper-pagination-total">${slidesNum}</span>`;

				},
			},
		} );

	}

};


const breakpoints = {
	0: {
		spaceBetween: 32,
		slidesPerView: 1.3,
	},
	786: {
		spaceBetween: 32,
		slidesPerView: 2.2,
	},
	1100: {
		spaceBetween: 32,
		slidesPerView: 3,
	},
}

document.querySelectorAll( '.b-related-posts' ).forEach( ( block ) => {

	initializeSwiper( block );

} );
